const getCommentIdsFromDelta = (delta) => {
  const commentIds = delta.ops.reduce((IdsArray, op) => {
    if (op?.attributes?.highlight?.id) {
      IdsArray.push(op.attributes.highlight.id.split('-')[1]);
    }
    return IdsArray;
  }, []);

  return commentIds;
};

export default getCommentIdsFromDelta;
